/**
 * Where a person was going, read from a message's link.
 *
 * A link written by Accounts carries the address the message was asked for in `next` (an address of
 * this interface, with the sign-in's `to`, `product` and `return`); an older link carries them in its
 * own query. `next` is read only when it is an address of this interface's own origin, and only its
 * query is kept: every value in it is validated again where it is followed (`Confirmation`, `Return`).
 */
export class Carried {
	#parameters: URLSearchParams;
	#origin: string;

	constructor(parameters: URLSearchParams, origin: string) {
		this.#parameters = parameters;
		this.#origin = origin;
	}

	get parameters(): URLSearchParams {
		const next = this.#parameters.get('next');
		if (next) {
			try {
				const url = new URL(next);
				if (url.origin === this.#origin) return new URLSearchParams(url.search);
			} catch {
				// Not an address: nothing is carried
			}
			return new URLSearchParams();
		}
		const own = new URLSearchParams(this.#parameters);
		for (const name of ['token_hash', 'type', 'code', 'error', 'error_description']) own.delete(name);
		return own;
	}
}
